/**
 * CK Custom PC Builder - Interactive Engine
 * Pure Vanilla JS with isolated Print & Calculation logic
 */

(function () {
  'use strict';

  function initBuilder() {
    var root = document.getElementById('ck-custom-builder-root');
    if (!root) return;

    var summaryList = document.getElementById('ck-summary-items-list');
    var subtotalEl = document.getElementById('ck-calc-subtotal');
    var gstEl = document.getElementById('ck-calc-gst');
    var totalEl = document.getElementById('ck-calc-total');
    var addCartBtn = document.getElementById('ck-btn-add-cart');
    var whatsappBtn = document.getElementById('ck-btn-whatsapp');
    var printBtn = document.getElementById('ck-btn-print');

    var currentItems = [];
    var currentTotal = 0;

    function formatINR(num) {
      return '₹' + Number(num).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    }

    // Sub-type filter: narrow a category's <select> to options whose tags/name match.
    function applyFilter(radio) {
      var group = radio.closest('.ck-form-group');
      if (!group) return;
      var select = group.querySelector('.ck-select');
      if (!select) return;
      var val = (radio.value || 'all').toLowerCase();
      var currentValue = select.value;
      var currentStillVisible = false;
      var visibleCount = 0;

      Array.prototype.forEach.call(select.options, function (opt) {
        if (!opt.value) return; // leave the "-- Select --" placeholder alone
        var rawTags = (opt.getAttribute('data-tags') || '').toLowerCase();
        var always = opt.value === 'none' || rawTags === 'all';
        // Match the pill token against whole product tags (incl. "prefix:value"
        // tags), then fall back to the product name.
        var tokens = rawTags.split('|');
        var name = (opt.getAttribute('data-name') || '').toLowerCase();
        var matchTag = tokens.some(function (t) {
          t = t.trim();
          return t === val || t.split(':').pop().trim() === val;
        });
        var show = val === 'all' || always || matchTag || name.indexOf(val) !== -1;
        opt.hidden = !show;
        opt.disabled = !show;
        if (show) {
          visibleCount++;
          if (opt.value === currentValue) currentStillVisible = true;
        }
      });

      // If the current pick no longer matches the filter, reset to placeholder.
      if (currentValue && !currentStillVisible) {
        select.value = '';
      }

      var badge = group.querySelector('.ck-slot__badge');
      if (badge) {
        badge.textContent = visibleCount + (visibleCount === 1 ? ' option' : ' options');
      }
    }

    root.querySelectorAll('.ck-filter-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        applyFilter(radio);
        recalculate();
      });
    });

    function recalculate() {
      var allSelects = root.querySelectorAll('.ck-select');
      var totalPrice = 0;
      var items = [];
      var whatsappLines = [
        '*CPU Kart (Right Solutions) Custom PC Specification*',
        '----------------------------------'
      ];

      allSelects.forEach(function (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (!opt || opt.disabled || !opt.value) return;

        var price = parseFloat(opt.getAttribute('data-price') || '0');
        var name = opt.getAttribute('data-name') || opt.text;
        var slot = sel.getAttribute('data-slot') || sel.id;
        var variantId = opt.getAttribute('data-variant-id') || '';

        totalPrice += price;

        items.push({
          slot: slot,
          name: name,
          price: price,
          variantId: variantId
        });

        whatsappLines.push('• *' + slot + '*: ' + name + ' (' + formatINR(price) + ')');
      });

      currentItems = items;
      currentTotal = totalPrice;

      // Render summary items
      if (items.length > 0) {
        var html = '';
        items.forEach(function (it) {
          html += '<div class="ck-summary-item">';
          html += '  <div>';
          html += '    <span class="ck-summary-item__label">' + it.slot + '</span>';
          html += '    <div class="ck-summary-item__name" title="' + it.name + '">' + it.name + '</div>';
          html += '  </div>';
          html += '  <div class="ck-summary-item__price">' + (it.price > 0 ? formatINR(it.price) : 'Incl.') + '</div>';
          html += '</div>';
        });
        summaryList.innerHTML = html;
      } else {
        summaryList.innerHTML = '<div class="ck-summary-empty">No components selected yet. Please select your options above.</div>';
      }

      // Calculations
      var gstPortion = totalPrice * 0.18 / 1.18;
      if (subtotalEl) subtotalEl.textContent = formatINR(totalPrice);
      if (gstEl) gstEl.textContent = formatINR(gstPortion);
      if (totalEl) totalEl.textContent = formatINR(totalPrice);

      // WhatsApp link
      whatsappLines.push('----------------------------------');
      whatsappLines.push('*Total Price (incl. GST):* ' + formatINR(totalPrice));
      whatsappLines.push('\nHello CPU Kart (Right Solutions) team, I would like to order / verify this custom build configuration!');

      if (whatsappBtn) {
        var encoded = encodeURIComponent(whatsappLines.join('\n'));
        whatsappBtn.href = 'https://wa.me/919029176911?text=' + encoded;
      }
    }

    // Bind change listener on all selects
    root.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('ck-select')) {
        recalculate();
      }
    });

    // Invoice Print Handler
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        var today = new Date();
        var dateStr = today.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
        var invoiceNo = 'CK-' + today.getFullYear() + ('0' + (today.getMonth() + 1)).slice(-2) + ('0' + today.getDate()).slice(-2) + '-' + Math.floor(1000 + Math.random() * 9000);
        var gstVal = currentTotal * 0.18 / 1.18;

        var rowsHtml = '';
        if (currentItems.length > 0) {
          currentItems.forEach(function (item, idx) {
            rowsHtml += '<tr>';
            rowsHtml += '  <td style="text-align:center;border:1px solid #000;padding:6px 8px;">' + (idx + 1) + '</td>';
            rowsHtml += '  <td style="border:1px solid #000;padding:6px 8px;font-weight:600;">' + item.slot + '</td>';
            rowsHtml += '  <td style="border:1px solid #000;padding:6px 8px;">' + item.name + '</td>';
            rowsHtml += '  <td style="text-align:center;border:1px solid #000;padding:6px 8px;">1</td>';
            rowsHtml += '  <td style="text-align:right;border:1px solid #000;padding:6px 8px;font-weight:600;">' + (item.price > 0 ? formatINR(item.price) : '₹0') + '</td>';
            rowsHtml += '</tr>';
          });
        } else {
          rowsHtml = '<tr><td colspan="5" style="text-align:center;border:1px solid #000;padding:12px;color:#555;">No components selected</td></tr>';
        }

        var printDoc = [
          '<!DOCTYPE html>',
          '<html>',
          '<head>',
          '  <meta charset="utf-8">',
          '  <title>Invoice ' + invoiceNo + ' - CPU Kart (Right Solutions)</title>',
          '  <style>',
          '    @page { size: A4 portrait; margin: 15mm; }',
          '    * { box-sizing: border-box; margin: 0; padding: 0; }',
          '    body { font-family: Arial, Helvetica, sans-serif; color: #000; background: #fff; padding: 20px; font-size: 12px; line-height: 1.4; }',
          '    .header-table { width: 100%; border-collapse: collapse; border-bottom: 2px solid #000; margin-bottom: 18px; padding-bottom: 12px; }',
          '    .header-table td { vertical-align: top; }',
          '    .brand-title { font-size: 20px; font-weight: bold; text-transform: uppercase; }',
          '    .brand-meta { font-size: 11px; color: #333; margin-top: 4px; }',
          '    .inv-title { font-size: 18px; font-weight: bold; text-align: right; text-transform: uppercase; }',
          '    .inv-meta { font-size: 11px; text-align: right; margin-top: 4px; }',
          '    .items-table { width: 100%; border-collapse: collapse; margin-bottom: 18px; }',
          '    .items-table th { background: #f0f0f0; border: 1px solid #000; padding: 7px 8px; font-size: 11px; text-transform: uppercase; text-align: left; }',
          '    .totals-table { width: 300px; border-collapse: collapse; margin-left: auto; margin-bottom: 24px; }',
          '    .totals-table td { border: 1px solid #000; padding: 6px 10px; font-size: 12px; }',
          '    .totals-table .t-label { background: #f9f9f9; font-weight: 600; }',
          '    .totals-table .t-val { text-align: right; font-weight: bold; }',
          '    .totals-table .grand td { background: #f0f0f0; font-size: 14px; font-weight: bold; }',
          '    .footer { border-top: 1px solid #000; padding-top: 10px; font-size: 10px; color: #444; }',
          '  </style>',
          '</head>',
          '<body>',
          '  <table class="header-table">',
          '    <tr>',
          '      <td>',
          '        <div class="brand-title">CPU Kart (Right Solutions)</div>',
          '        <div class="brand-meta">Website: cpukart.com | Email: support@cpukart.com | Tel: +91 90291 76911</div>',
          '      </td>',
          '      <td>',
          '        <div class="inv-title">ESTIMATE INVOICE</div>',
          '        <div class="inv-meta"><strong>Ref:</strong> ' + invoiceNo + '<br><strong>Date:</strong> ' + dateStr + '</div>',
          '      </td>',
          '    </tr>',
          '  </table>',
          '  <table class="items-table">',
          '    <thead>',
          '      <tr>',
          '        <th style="width:35px;text-align:center;">#</th>',
          '        <th style="width:140px;">Category</th>',
          '        <th>Item Description</th>',
          '        <th style="width:45px;text-align:center;">Qty</th>',
          '        <th style="width:110px;text-align:right;">Amount (INR)</th>',
          '      </tr>',
          '    </thead>',
          '    <tbody>',
          '      ' + rowsHtml,
          '    </tbody>',
          '  </table>',
          '  <table class="totals-table">',
          '    <tr><td class="t-label">Subtotal:</td><td class="t-val">' + formatINR(currentTotal) + '</td></tr>',
          '    <tr><td class="t-label">GST (18% Included):</td><td class="t-val">' + formatINR(gstVal) + '</td></tr>',
          '    <tr class="grand"><td class="t-label">Total Amount:</td><td class="t-val">' + formatINR(currentTotal) + '</td></tr>',
          '  </table>',
          '  <div class="footer">CPU Kart (Right Solutions) — Computer-generated specification invoice.</div>',
          '</body>',
          '</html>'
        ].join('\n');

        var iframe = document.getElementById('ck-print-iframe');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.id = 'ck-print-iframe';
          iframe.style.position = 'fixed';
          iframe.style.right = '0';
          iframe.style.bottom = '0';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = 'none';
          document.body.appendChild(iframe);
        }

        var doc = iframe.contentWindow.document;
        doc.open();
        doc.write(printDoc);
        doc.close();

        setTimeout(function () {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }, 300);
      });
    }

    // Add to cart AJAX
    if (addCartBtn) {
      addCartBtn.addEventListener('click', function () {
        var originalText = addCartBtn.innerHTML;
        addCartBtn.disabled = true;
        addCartBtn.innerHTML = '<span>⏳ Adding Custom Build...</span>';

        var allSelects = root.querySelectorAll('.ck-select');
        var itemsToAdd = [];
        allSelects.forEach(function (sel) {
          var opt = sel.options[sel.selectedIndex];
          if (opt && opt.getAttribute('data-variant-id') && opt.getAttribute('data-variant-id').trim() !== '') {
            itemsToAdd.push({
              id: parseInt(opt.getAttribute('data-variant-id'), 10),
              quantity: 1,
              properties: {
                '_build_type': 'Custom PC Configurator',
                'Component Slot': (sel.getAttribute('data-slot') || 'Part')
              }
            });
          }
        });

        if (itemsToAdd.length === 0) {
          alert('Please select at least one component to add to cart.');
          addCartBtn.disabled = false;
          addCartBtn.innerHTML = originalText;
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        })
        .then(function (res) { return res.json(); })
        .then(function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('Cart add error:', err);
          window.location.href = '/cart';
        })
        .finally(function () {
          addCartBtn.disabled = false;
          addCartBtn.innerHTML = originalText;
        });
      });
    }

    // Initial calculation (starts at 0)
    recalculate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuilder);
  } else {
    initBuilder();
  }
})();
